import { DocumentTotals } from 'modules/Documents/models/document';
import { VerifactuInvoice } from 'modules/Documents/models/verifactuInvoice';

import { normalizeVerifactuReimbursableExpenseLinesToAdditionalExpenses } from './normalizeVerifactuReimbursableExpenseLinesToAdditionalExpenses';
import { normalizeVerifactuTaxesToDocumentTaxes } from './normalizeVerifactuTaxesToDocumentTaxes';

export const normalizeVerifactuTotalsToDocumentTotals = (
  verifactu: VerifactuInvoice
): DocumentTotals => {
  const { totals, reimbursableExpenseLines, taxLines } = verifactu;

  return {
    amountDue: totals.amountDue,
    discount: totals.discountAmount,
    paidAmount: totals.paidAmount,
    additionalExpenses: reimbursableExpenseLines
      ? normalizeVerifactuReimbursableExpenseLinesToAdditionalExpenses(
          reimbursableExpenseLines
        )
      : [],
    retentionPercentage: totals.withholdingRate,
    retentions: totals.withholdingAmount,
    salesEqTax: taxLines.reduce(
      (acc, taxLine) => acc + (taxLine.equivalenceSurchargeAmount || 0),
      0
    ),
    subtotal: totals.subTotalAmount,
    taxAmount: totals.taxAmount,
    taxBase: totals.taxBase,
    taxes: normalizeVerifactuTaxesToDocumentTaxes(verifactu),
    total: totals.totalAmount,
    totalExpenses: totals.reimbursableExpensesAmount,
  };
};
